(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name etsReport.controller:EtsReportCtrl
   *
   * @description
   *
   */
  angular
    .module('etsReport')
    .controller('EtsReportCtrl', EtsReportCtrl);

  function EtsReportCtrl(CommonMasterData,$sce,CommonLogicService) {
    var vm = this;
    vm.ctrlName = 'EtsReportCtrl';

    vm.reportTypes = {
      TKM : 'tkm',
      EMISSION : 'emission'
    }
    vm.model = {
      searchPanelToggle : true,
      searchCriteria : {
        fromDate : null,
        toDate : null,
        acReg : null,
        origin: null,
        destination :null,
        originCountry : null,
        destinationCountry: null,
        reportType:null,
        downloadCSV:false,
        downloadExel:false,
        reportCategory:null,
        operationType: null
      },
      masterList : {
        crewTypes:[],
        crewList:[],
        leaveTypeList:[],
        acRegList:[],
        airportList:[],
        countryList:[],
        reportCategory:[{value:'ETS'},{value:'CORSIA'}],
        fromTimeInvalid : false,
        toTimeInvalid : false,
        downloadTypesInvalid : false,
        operationTypes : null
      },
      initialSearchDone : false,
      reportDataURL : null,
      reportServerBaseUrl : null
    };


    vm.submitSearch = function(params) {
      searchLeaveDetailsReport(params);
    };


    vm.clickOnSearch = function() {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };


    function searchLeaveDetailsReport(param) {
      vm.model.initialSearchDone = true;
      if (isValidSearchParams(param)) {
        vm.model.searchCriteria = param;
        vm.model.searchPanelToggle = false;

        var type = getReportType(param.reportType);
        var rptDesign = "";
        switch (type){
          case vm.reportTypes.TKM :
            rptDesign = "tkm_report.rptdesign";
            break;
          case vm.reportTypes.EMISSION :
            rptDesign = "ets_emission_report.rptdesign";
            break;
          default :
            rptDesign = "tkm_report.rptdesign";
            break;
        }

        if(rptDesign == "ets_emission_report.rptdesign" && (vm.model.searchCriteria.downloadCSV || vm.model.searchCriteria.downloadExel)){
          rptDesign = "etsReportDownload";
        }


        var url = CommonLogicService.getReportUrl(rptDesign, getSearchParamMap(param));
        console.log(url);
        vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
      }
    }

    function getSearchParamMap(param) {
      var searchParamMap = {};
      searchParamMap["fromDate"] = param.fromDate;
      searchParamMap["toDate"] = param.toDate;
      searchParamMap["oAirport"] = '';
      if (!!param.origin && !!param.origin.airPortCode) {
        searchParamMap["oAirport"] = param.origin.airPortCode;
      }
      searchParamMap["dAirport"] = '';
      if (!!param.destination && !!param.destination.airPortCode) {
        searchParamMap["dAirport"] = param.destination.airPortCode;
      }

      searchParamMap["oCountry"] = '';
      if (!!param.originCountry && !!param.originCountry.code) {
        searchParamMap["oCountry"] = param.originCountry.code;
      }
      searchParamMap["dCountry"] = '';
      if (!!param.destinationCountry && !!param.destinationCountry.code) {
        searchParamMap["dCountry"] = param.destinationCountry.code;
      }
      searchParamMap["flightReg"] = '';
      if (!!param.acReg && !!param.acReg.registrationID) {
        searchParamMap["flightReg"] = param.acReg.registrationID;
      }
      searchParamMap["operationType"] = '';
      if (!!param.operationType && !!param.operationType.operationTypeCode) {
        searchParamMap["operationType"] = param.operationType.operationTypeCode;
      }
      searchParamMap["reportDownloadType"] = '';
      if (param.downloadExel === true) {
        searchParamMap["reportDownloadType"] = 'exel';
      }
      if (param.downloadCSV === true) {
        searchParamMap["reportDownloadType"] = 'csv';
      }
      if(param.reportType !== null){
        searchParamMap["category"] = param.reportCategory.value;
      }

      return searchParamMap;
    }


    function isValidSearchParams(params) {
      setDateValidationFlags();
      if(((!!vm.model.searchCriteria.fromDate && !vm.model.masterList.fromTimeInvalid)||
        (!!vm.model.searchCriteria.toDate && !vm.model.masterList.toTimeInvalid)
      ) && isValidDownloadType(params)){
        return true;
      }
      return false;
    }

    function isValidDownloadType(params) {
      if (params.downloadCSV && params.downloadExel) {
        vm.model.masterList.downloadTypesInvalid = true;
        return false;
      }
      return true;
    }

    function setDateValidationFlags() {
      //if from date invalid
      if(isDateFormatInvalid(vm.model.searchCriteria.fromDate)){
        vm.model.masterList.fromTimeInvalid = true;
      }else{
        vm.model.masterList.fromTimeInvalid = false;
      }
      if(isDateFormatInvalid(vm.model.searchCriteria.toDate)){
        vm.model.masterList.toTimeInvalid = true;
      }else{
        vm.model.masterList.toTimeInvalid = false;
      }

    }

    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    }

    function getReportType(reportType){
      if(reportType === null ){
        return vm.reportTypes.TKM;
      }else if(!reportType){
        return vm.reportTypes.EMISSION;
      }
    }

    (function loadAirportList() {
      CommonMasterData.getAirportList(
        function (airports) {
          vm.model.masterList.airportList = airports;
        },
        function () {
          console.log('origin/Destination Airport retrieval error');
        }
      );
    })();

    (function loadCountryList() {
      CommonMasterData.getCountryList(
        function (countries) {
          vm.model.masterList.countryList = countries;
        },
        function () {
          console.log('origin/Destination Country retrieval error');
        }
      );
    })();

    (function loadAircraftList() {
      var param = {
        pageSize: 200,
        startPosition: 0,
        isActive:true

      };
      CommonMasterData.getAircraftList(param,
        function (ACRegs) {
          vm.model.masterList.acRegList = ACRegs;
        },
        function () {
          console.log('A/C Registrations retrieval error');
        }
      );
    })();

    (function() {
      // load airport list
      CommonMasterData.getFlightOperationTypes(function(operationTypes) {
        vm.model.masterList.operationTypes = operationTypes;
      }, function(error) {
        console.log('Operation Types retrieval error!!!');
      });

    })();


  }
}());


// loadCountryList
// loadAircraftList
// loadAirportList
